export default __webpack_public_path__ + "static/media/online_banking.e7bb3b13.svg";